import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const { pathname } = useLocation();
  // Anchor targets only exist on the home page; elsewhere, link back to it
  const base = pathname === '/' ? '' : '/';
  // Service pages carry their own contact form; the privacy page does not
  const contactBase = pathname === '/privacy-policy' ? '/' : '';

  return (
    <footer className="footer" data-testid="main-footer">
      <div className="wrap">
      <div className="footer-top">
        <a href="/" className="footer-brand" aria-label="Rapid Rune home">
          <img src="/icons/logo.png" alt="" width="152" height="96" />
          <span>Rapid Rune</span>
        </a>
        <p className="footer-tag">Automation and IT consulting for teams that want to move faster.</p>
      </div>

      <div className="footer-grid">
        <div className="footer-col">
          <h2>Services</h2>
          <a href="/services/process-automation">Process Automation</a>
          <a href="/services/it-consulting-email-security">IT &amp; Email Security</a>
          <a href="/services/microsoft-365-google-workspace">M365 &amp; Workspace</a>
          <a href="/services/marketing-automation">Marketing Automation</a>
        </div>
        <div className="footer-col">
          <h2>Site</h2>
          <a href={`${base}#services`}>Services</a>
          <a href={`${base}#process`}>Process</a>
          <a href={`${base}#why`}>Why us</a>
          <a href={`${base}#faq`}>Questions</a>
        </div>
        <div className="footer-col">
          <h2>Company</h2>
          <a href="https://portal.rapidrune.com" data-testid="footer-portal-link">Client portal</a>
          <a href="/privacy-policy" data-testid="footer-privacy-link">Privacy policy</a>
        </div>
        <div className="footer-contact">
          <a href="mailto:inquire@rapidrune.com">inquire@rapidrune.com</a>
          <p>Remote, serving clients across the United States.</p>
        </div>
      </div>

      <div className="footer-bottom">
        <small>© 2026 Rapid Rune LLC. All rights reserved.</small>
        <a href={`${contactBase}#contact`} className="btn btn-accent btn-small" data-testid="footer-cta">
          Start a project
        </a>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
